import { useState } from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import { useNavigate, generatePath } from "react-router-dom";
export default function Policy() {
  const [activeTab, setActiveTab] = useState("privacy");
  const [hideSidebar, setHideSidebar] = useState(true);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(generatePath("/client"));
  };

  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      <div className="dashboard_body_main vh-100">
        <div className="policy-container">
          {/* Header */}
          <div className="policy-header">
            <h1 className="policy-title">
              Legal — Privacy &amp; Terms{" "}
              <span className="policy-pill">Last updated: 6 October 2025</span>
            </h1>
            <p className="policy-sub">
              Fire Inspect Pvt Ltd • Azure UK South • SendGrid • Stripe
            </p>
          </div>

          {/* Tabs */}
          <div className="policy-tabs">
            <div
              className={`policy-tab ${
                activeTab === "privacy" ? "tab-active" : ""
              }`}
              onClick={() => setActiveTab("privacy")}
            >
              Privacy Policy
            </div>
            <div
              className={`policy-tab ${
                activeTab === "terms" ? "tab-active" : ""
              }`}
              onClick={() => setActiveTab("terms")}
            >
              Terms of Use
            </div>
            <div
              className={`policy-tab ${
                activeTab === "cookies" ? "tab-active" : ""
              }`}
              onClick={() => setActiveTab("cookies")}
            >
              Cookies
            </div>
          </div>

          {/* Panels */}
          <div className="policy-panels">
            {/* Privacy Policy */}
            {activeTab === "privacy" && (
              <div className="policy-panel">
                <p>
                  This Privacy Policy explains how{" "}
                  <strong>Fire Inspect Pvt Ltd </strong>
                  (“we”, “us”, or “our”) collects, uses, and protects your
                  personal data when you use our fire-door survey website and
                  mobile application (“Services”). We comply with the{" "}
                  <strong>UK GDPR</strong> and the{" "}
                  <strong>Data Protection Act 2018</strong>.
                </p>

                {/* Section 1 */}
                <div className="policy-section">
                  <div className="policy-heading">
                    1) Who We Are &amp; Contacts
                  </div>
                  <div className="policy-text">
                    <strong>
                      Data Controller (website, accounts, billing, support,
                      product analytics):
                    </strong>
                    <br />
                    Fire Inspect Pvt Ltd, registered in England &amp; Wales
                    <br />
                    Address: <em>[Insert Registered Address]</em>
                    <br />
                    Email:{" "}
                    <a href="mailto:privacy@fireinspect.co.uk">
                      privacy@fireinspect.co.uk
                    </a>
                  </div>
                </div>

                {/* Section 2 */}
                <div className="policy-section">
                  <div className="policy-heading">2) Data We Collect</div>

                  <div className="policy-card">
                    <div className="policy-subheading">A) You Provide</div>
                    <ul>
                      <li>
                        Account &amp; profile (name, email, phone, company,
                        password—hashed).
                      </li>
                      <li>
                        Inspection data (forms, properties/doors, measurements,
                        approvals).
                      </li>
                      <li>
                        Media (photos/videos of hinges, signage, self-closers,
                        strips; annotations).
                      </li>
                      <li>Support requests and attachments.</li>
                      <li>
                        Billing/org details; card data handled by{" "}
                        <strong>Stripe</strong>.
                      </li>
                    </ul>
                  </div>

                  <div className="policy-card">
                    <div className="policy-subheading">
                      B) Collected Automatically
                    </div>
                    <ul>
                      <li>
                        Device/logs (IP, OS, browser/app version, crash logs,
                        timezone).
                      </li>
                      <li>
                        Usage (screens visited, features used, timestamps).
                      </li>
                      <li>
                        Cookies/SDKs for sessions and diagnostics (e.g., Azure
                        Insights).
                      </li>
                      <li>
                        Approximate location (if enabled) to tag inspections.
                      </li>
                    </ul>
                  </div>

                  <div className="policy-card">
                    <div className="policy-subheading">
                      C) From Third Parties
                    </div>
                    <ul>
                      <li>SSO (Microsoft/Google/Apple basic profile).</li>
                      <li>
                        Client imports/integrations (Azure AD, SharePoint,
                        connectors).
                      </li>
                    </ul>
                    <p className="hl small">
                      <strong>Incidental capture:</strong> Avoid photographing
                      people or sensitive documents.
                    </p>
                  </div>
                </div>

                {/* Section 3 */}
                <div className="policy-section">
                  <div className="policy-heading">
                    3) AI &amp; Automated Analysis
                  </div>
                  <div className="policy-text">
                    <ul>
                      <li>
                        Computer vision detects door issues (hinge gaps,
                        signage, self-closers, strips, etc.) and suggests action
                        items with severity &amp; remediation options.
                      </li>
                      <li>
                        <strong>Human-in-the-loop:</strong> AI outputs are
                        recommendations. Qualified inspectors must review before
                        finalising reports.
                      </li>
                      <li>
                        <strong>Explainability:</strong> highlight boxes/labels
                        and measurement rationale where available.
                      </li>
                      <li>
                        <strong>Model improvement:</strong> de-identified data
                        may be used to improve models; opt out anytime at{" "}
                        <a href="mailto:privacy@fireinspect.co.uk">
                          privacy@fireinspect.co.uk
                        </a>
                        .
                      </li>
                      <li>
                        No solely automated decisions with legal/similarly
                        significant effects.
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Section 4 */}
                <div className="policy-section">
                  <div className="policy-heading">4) Lawful Bases</div>
                  <ul>
                    <li>Contract (Art. 6(1)(b)) — deliver Services.</li>
                    <li>
                      Legitimate interests (Art. 6(1)(f)) — security, quality,
                      analytics, AI assistance.
                    </li>
                    <li>
                      Consent (Art. 6(1)(a)) — marketing and optional
                      permissions.
                    </li>
                    <li>Legal obligation (Art. 6(1)(c)).</li>
                  </ul>
                </div>

                {/* Section 5 */}
                <div className="policy-section">
                  <div className="policy-heading">5) Uses of Data</div>
                  <ul>
                    <li>Surveys, AI analysis, approvals, PDF reports.</li>
                    <li>Action-item generation and cost bands.</li>
                    <li>Authentication, account management.</li>
                    <li>Billing via Stripe; emails/alerts via SendGrid.</li>
                    <li>
                      Performance &amp; security monitoring (Azure UK South,
                      Application Insights).
                    </li>
                  </ul>
                </div>

                {/* Section 6 */}
                <div className="policy-section">
                  <div className="policy-heading">6) Sharing</div>
                  <ul>
                    <li>
                      Your authorised org members
                      (Inspectors/Approvers/Clients).
                    </li>
                    <li>
                      Processors: <strong>Microsoft Azure (UK South)</strong>,{" "}
                      <strong>SendGrid</strong>, <strong>Stripe</strong>.
                    </li>
                    <li>
                      Authorities as required by law; corporate transactions
                      with safeguards.
                    </li>
                  </ul>
                  <p>
                    We do <strong>not</strong> sell personal data.
                  </p>
                </div>

                {/* Section 7 */}
                <div className="policy-section">
                  <div className="policy-heading">
                    7) International Transfers
                  </div>
                  <p>
                    Primary hosting: <strong>Azure UK South</strong>. If data
                    leaves the UK (e.g., for email routing or Stripe), we use
                    UK-approved SCCs and appropriate safeguards.
                  </p>
                </div>

                {/* Section 8 */}
                <div className="policy-section">
                  <div className="policy-heading">8) Retention</div>
                  <ul>
                    <li>
                      Inspection records: up to 7 years or per client policy
                      (soft-delete ~30 days, then purge).
                    </li>
                    <li>Logs/diagnostics: 90–180 days..</li>
                    <li>Billing: 6 years (statutory).</li>
                  </ul>
                </div>

                {/* Section 9 */}
                <div className="policy-section">
                  <div className="policy-heading">9) Security</div>
                  <ul>
                    <li>
                      TLS in transit; encryption at rest; RBAC; audit logs..
                    </li>
                    <li>
                      MFA options for admins; vulnerability management; incident
                      response.
                    </li>
                  </ul>
                </div>

                {/* Section 10 */}
                <div className="policy-section">
                  <div className="policy-heading">10) Your Rights (UK)</div>
                  <p>
                    Access, rectification, erasure, restriction, portability,
                    objection, withdraw consent. Contact:
                    privacy@fireinspect.co.uk. End-users of client orgs should
                    contact their controller first; we assist as processor.
                  </p>
                </div>

                {/* Section 11 */}
                <div className="policy-section">
                  <div className="policy-heading">
                    11) Cookies &amp; Mobile Permissions
                  </div>
                  <ul>
                    <li>Essential cookies (login/session).</li>
                    <li>Analytics (Azure App Insights) with consent.</li>
                    <li>
                      Camera/photos/location/notifications (optional,
                      controllable in device settings).
                    </li>
                  </ul>
                </div>

                {/* Section 12 */}
                <div className="policy-section">
                  <div className="policy-heading">12) Children</div>
                  <p>Not intended for under-16s.</p>
                </div>

                {/* Section 13 */}
                <div className="policy-section">
                  <div className="policy-heading">
                    13) DPIA &amp; Accountability
                  </div>
                  <p>
                    DPIAs maintained; model performance and bias reviewed;
                    human-review enforced.
                  </p>
                </div>

                {/* Section 14 */}
                <div className="policy-section">
                  <div className="policy-heading">14) Changes</div>
                  <p>
                    We’ll post updates here and notify admins where appropriate.
                  </p>
                </div>

                {/* Section 15 */}
                <div className="policy-section">
                  <div className="policy-heading">15) Complaints</div>
                  <p>
                    Contact:{" "}
                    <a href="mailto:privacy@fireinspect.co.uk">
                      privacy@fireinspect.co.uk
                    </a>
                    . ICO:{" "}
                    <a
                      href="https://ico.org.uk"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://ico.org.uk
                    </a>
                  </p>
                </div>
              </div>
            )}

            {activeTab === "terms" && (
              <div className="policy-panel">
                <div className="policy-section">
                  <div className="policy-heading">Terms of Use</div>

                  <div className="muted">
                    These Terms govern your use of the Fire Inspect Pvt Ltd
                    fire-door survey web & mobile platform. By using the
                    Services you agree to these Terms.
                  </div>

                  <div>
                    <div className="policy-heading">1) Company Info</div>
                    <ul>
                      <li>
                        Fire Inspect Pvt Ltd, registered in England &amp; Wales
                      </li>
                      <li>
                        Address: <em>[Insert Registered Address]</em>
                      </li>
                      <li>
                        Email:{" "}
                        <a href="mailto:support@fireinspect.co.uk">
                          support@fireinspect.co.uk
                        </a>
                      </li>
                      <li>
                        Website:{" "}
                        <a href="https://fireinspect.co.uk">
                          fireinspect.co.uk
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">
                      2) Acceptance & Eligibility
                    </div>

                    <div>
                      You confirm you are 18+ and authorised to bind your
                      organisation. If you do not agree, do not use the
                      Services.
                    </div>
                  </div>

                  <div>
                    <div className="policy-heading">3) Accounts & Security</div>
                    <ul>
                      <li>
                        Keep credentials confidential; notify us of unauthorised
                        use.
                      </li>
                      <li>
                        Accounts are organisation-scoped; no sharing outside
                        your entity.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">4) Services Overview</div>
                    <ul>
                      <li>Create/manage inspections; capture photos/videos.</li>
                      <li>
                        AI-assisted detections (hinge gaps, signage,
                        self-closers, strips).
                      </li>
                      <li>
                        Auto-generated action items & remediation options.
                      </li>
                      <li>
                        PDF reporting; role-based workflows; multi-property
                        dashboards.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">5) AI Limitations</div>
                    <ul>
                      <li>
                        AI outputs are advisory; human inspectors must verify
                        and decide.
                      </li>
                      <li>
                        No liability for outcomes relying solely on AI
                        suggestions.
                      </li>
                      <li>
                        Anonymised/de-identified data may improve models
                        (opt-out via{" "}
                        <a href="mailto:privacy@fireinspect.co.uk">
                          privacy@fireinspect.co.uk
                        </a>
                        ).
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">
                      6) Subscriptions & Payments
                    </div>
                    <ul>
                      <li>
                        Billed via <strong>Stripe</strong> monthly/annually;
                        fees exclude taxes.
                      </li>
                      <li>
                        Auto-renew unless cancelled before renewal; no partial
                        refunds unless required by law.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">
                      7) User Responsibilities
                    </div>
                    <ul>
                      <li>
                        Provide accurate data; avoid capturing identifiable
                        persons where possible.
                      </li>
                      <li>
                        Comply with applicable fire safety regulations and laws.
                      </li>
                      <li>
                        No misuse, reverse-engineering, or upload of malicious
                        content.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">
                      8) Privacy & Data Protection
                    </div>
                    <div>
                      See our{" "}
                      <a href="#panel-privacy" className="js-switch">
                        Privacy Policy
                      </a>
                      . Data is processed in Azure UK South; emails via
                      SendGrid; payments via Stripe.
                    </div>
                  </div>

                  <div>
                    <div className="policy-heading">9) IP Rights & Licence</div>
                    <ul>
                      <li>
                        Platform, software, models, and docs are owned by Fire
                        Inspect Pvt Ltd or licensors.
                      </li>
                      <li>
                        We grant a non-exclusive, non-transferable licence for
                        internal compliance use.
                      </li>
                      <li>No copying/resale without written consent.</li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">10) Availability</div>
                    <div>
                      Target uptime 99.5%; maintenance may cause brief
                      interruptions.
                    </div>
                  </div>

                  <div>
                    <div className="policy-heading">11) Liability</div>
                    <ul>
                      <li>
                        Provided “as is” and “as available”; all implied
                        warranties excluded where lawful.
                      </li>
                      <li>
                        No liability for indirect or consequential losses.
                      </li>
                      <li>
                        Aggregate liability capped at fees paid in the preceding
                        12 months.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <div className="policy-heading">
                      12) Suspension/Termination
                    </div>
                    <div>
                      We may suspend/terminate for breaches or misuse. Fees
                      already due remain payable.
                    </div>
                  </div>

                  <div>
                    <div className="policy-heading">13) Changes</div>
                    <div>
                      We may update these Terms; continued use signifies
                      acceptance.
                    </div>
                  </div>

                  <div>
                    <div className="policy-heading">14) Law & Jurisdiction</div>
                    <div>
                      England & Wales law; exclusive jurisdiction of its courts.
                    </div>
                  </div>

                  <div>
                    <div className="policy-heading">15) Contact</div>
                    <div>
                      support@fireinspect.co.uk •{" "}
                      <em>[Insert Registered Address]</em>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Cookies */}
            {activeTab === "cookies" && (
              <div className="policy-panel">
                <div className="policy-section">
                  <div className="policy-heading">Cookies</div>
                  <p>
                    Overview of how we use cookies/SDKs and how you can control
                    them.
                  </p>
                </div>
              </div>
            )}
         
          </div>

          {/* Footer */}
          <div className="policy-footer">
            <p>© 2025 Fire Inspect Pvt Ltd. All rights reserved.</p>
          </div>
        </div>
           <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
              <button
              style={{height: 'fit-content'}}
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  handleBack();
                }}
              >
                Back
              </button>
            </div>
        <Footer />
      </div>
    </>
  );
}
